import React, { useEffect, useState } from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import Button from "../../components/reusable/Button/Button";
import { dashboardAPI } from "../../Api/dashboardAPI";
import { toastError, toastInfo, toastSuccess } from "../../utils/toast";
import PageLoader from "../../components/reusable/PageLoader/PageLoader";
import SlOption from "@shoelace-style/shoelace/dist/react/option";
import SlSelect from "@shoelace-style/shoelace/dist/react/select";
import Divider from "../../components/reusable/Divider/Divider";
import { useSelector } from "react-redux";
import {
  selectEstadoDelSistema,
  setLoadingPageScreen,
} from "../../features/Dashboard/Slices/dashboardSlice";
import { getParametros } from "../../features/Dashboard/AsyncThunks/parametros/getParametros";
import { EstadoSistema, Parametros } from "../../interfaces/parametros";
import { useAppDispatch } from "../../app/store";
import ModalConfirmation from "../../components/reusable/ModalConfirmation/ModalConfirmation";
import useAuth from "../../hooks/useAuth";

function Home() {
  const paramEstadoSistema = useSelector(selectEstadoDelSistema);
  const [estadoSistema, setEstadoSistema] = useState<undefined | string>();
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const { hasPermission } = useAuth();
  const dispatch = useAppDispatch();

  const setLoading = (loaderState: boolean) => {
    dispatch(setLoadingPageScreen(loaderState));
  };

  const handleUpdateSystem = async () => {
    setLoading(true);
    try {
      if (estadoSistema) {
        await dashboardAPI.updateParametro(
          Parametros.EstadoSistema,
          estadoSistema
        );
        toastSuccess("Parámetro actualizado correctamente");
        await handleLogoutGeneral();
      } else {
        toastInfo("No se encuentra estado sistema seleccionado");
      }
    } catch (error: any) {
      toastError(error?.message);
    }
    setShowModalConfirmation(false);
    setLoading(false);
  };

  const getParams = async () => {
    setLoading(true);
    await dispatch(getParametros());
    setLoading(false);
  };

  const handleLogoutGeneral = async () => {
    setLoading(true);
    try {
      await dashboardAPI.logoutGeneral();
      toastSuccess("Logout - Broadcast enviado correctamente");
    } catch (error) {
      toastError();
    }
    setLoading(false);
  };

  useEffect(() => {
    getParams();
  }, []);

  useEffect(() => {
    if (paramEstadoSistema) {
      setEstadoSistema(paramEstadoSistema);
    }
  }, [paramEstadoSistema]);

  return (
    <div className="p-6 grid grid-cols-4 gap-6">
      <ModalConfirmation
        show={showModalConfirmation}
        onClose={() => setShowModalConfirmation(false)}
        onConfirm={handleUpdateSystem}
        title="¿Desea actualizar el estado del sistema?"
        message=""
      />
      {/* <h4 className="uppercase font-semibold text-primary border-b-[1px] border-primary pb-1 mb-4 mt-6 text-lg"> */}

      <div className="bg-white p-6 rounded-lg border-2 border-cardBorder col-span-1">
        <h4 className="font-semibold text-textSecondary mb-3 text-[16px]">
          Estado actual
        </h4>
        <div className="flex flex-col gap-2 items-start">
          <SlSelect
            size="small"
            value={estadoSistema}
            className="font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
            onSlChange={(e: any) => setEstadoSistema(e?.target?.value)}
            disabled={!hasPermission("home", "actualizar_sistema")}
          >
            <SlOption value={EstadoSistema.ABIERTO}>Abierto</SlOption>
            <SlOption value={EstadoSistema.BY_PASS}>By pass</SlOption>
            <SlOption value={EstadoSistema.CERRADO}>Cerrado</SlOption>
            <SlOption value={EstadoSistema.MANTENIMIENTO}>
              Mantenimiento
            </SlOption>
            <SlOption value={EstadoSistema.BY_PASS_SOPORTE}>
              By pass - Soporte
            </SlOption>
          </SlSelect>
          <button
            className="text-textPrimary font-bold flex items-center gap-2 hover:underline  border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => setShowModalConfirmation(true)}
            disabled={!hasPermission("home", "actualizar_sistema")}
          >
            Actualizar sistema
          </button>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg border-2 border-cardBorder col-span-2 self-start">
        <h4 className="font-semibold text-textSecondary mb-3 text-[16px]">
          Acciones globales
        </h4>
        <div className="flex items-center justify-between">
          <p className="text-secondary">
            Cerrar las sesiones activas de todos los usuarios.
          </p>
          <button
            className="text-textPrimary font-bold flex flex-nowrap items-center gap-2 hover:underline  border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleLogoutGeneral}
            disabled={!hasPermission("home", "logout_general")}
          >
            Logout general
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
